import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { loginAndRestartAppSelector } from 'selectors'
import clearMapComponents from 'helpers/map/clearMapComponents'
import { LOGIN_AND_RESTART_APP } from 'actions/applicationActionTypes'
import { notifyHoneybadgerAction, setupProjectsAction, waitForMapIdleAction } from 'actions/applicationActions'
import { clearProjectsAction } from 'actions/projectActions'
import { notificationAction } from 'actions/notificationActions'
import compressProject from 'helpers/projects/compressProject'
import projectDefaults from 'helpers/projects/projectDefaults'

export function * loginAndRestartApp(action) {
  try {
    const { map, currentEntity, cameras, mapLocation, zoom, ui, title,
      createdAt, mapType, floorPlans, markups,
      manufacturerSpecific, cameraDataFilename, entities } = yield select(loginAndRestartAppSelector)
    const { active } = action

    const offlineProject = {
      ...projectDefaults(),
      ...compressProject({ updatedAt: Date.now(), cameras, mapLocation, zoom, ui, title, createdAt,
        mapType, floorPlans, markups, currentEntity, entities })
    }

    if (manufacturerSpecific) window.history.pushState({}, document.title, '/')

    const projectEdited = cameras.length || ['networkClosets', 'wiredDevices', 'doorControllers'].some(type => entities[type].allIds.length) || markups.length || title !== 'New Project'

    yield call(clearMapComponents, { map, cameras })
    yield put(waitForMapIdleAction(map.ref))
    yield put(clearProjectsAction())
    yield put(setupProjectsAction(
      !active,
      active,
      projectEdited ? offlineProject : null,
      cameraDataFilename
    ))
    yield put(notificationAction('Signed in successfully', 'none'))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export function * watchLoginAndRestartApp() {
  yield * takeEvery(LOGIN_AND_RESTART_APP, loginAndRestartApp)
}



// WEBPACK FOOTER //
// ./src/sagas/loginAndRestartAppSaga.js